Hop.defineModule('acquisition-sticky-share', (domRoot) => {
    const domContainer = domRoot;
    const domShareList = domRoot.querySelector('[data-share-list]');
    const SHARE_LIST_OFFSET_TOP_LIM = document.querySelector('.hopheader').clientHeight + 60;
    const SHARE_LIST_STICKY_CLASS = 'STICKY';
    let IS_STICKY = false;

    function hasToBeSticky() {
        return domContainer.offset().top - SHARE_LIST_OFFSET_TOP_LIM < 0;
    }

    function toggleSticky() {
        if (!IS_STICKY && hasToBeSticky()) {
            domShareList.style.left = `${domShareList.offset().left}px`;
            domShareList.style.top = `${SHARE_LIST_OFFSET_TOP_LIM}px`;
            domShareList.classList.add(SHARE_LIST_STICKY_CLASS);
            IS_STICKY = true;
        } else if (IS_STICKY && !hasToBeSticky()) {
            domShareList.style.left = '';
            domShareList.style.top = '';
            domShareList.classList.remove(SHARE_LIST_STICKY_CLASS);
            IS_STICKY = false;
        }
    }

    function listenToUserScroll() {
        window.addEventListener('scroll', toggleSticky);
    }

    window.matchMedia('(min-width: 992px)').matches && listenToUserScroll();
});
